if(window.innerWidth>750){
    var Wflag = true,box2V=4.5,box9S=12000,box9V=5
}else{
    Wflag = false,box2V=1.5,box9S=8000,box9V=2
}

new Vue({
    el:'#oxflavor',
    data(){
        return{
            // 加载完成
            loadFlag:false,
            // 发送验证码标识
            sendFlag:false,
            loginFlag:false,
            popup:false,
            loginPopup:false,
            rulePopup:false,
            sharePopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            findText:'',
            user:{
                name:'',
                email:'',
                code:'',
                country:'Country'
            },
            submitFlag:true,
            popup1:false,
            select_flag1:0,
            countryArr:[], 
            active1:-1,
            active2:-1,
            active3:-1,
            flavorArr:[
                [
                    [
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blue-Razz-Gummy.jpg?v=1745317890',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Mixed-Grapes.jpg?v=1745317892',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Strawberry-Vanilla-Ice-Cream.jpg?v=1745317892'
                    ],
                    [
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Melon-Berries.jpg?v=1745317893',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blue-Bubble.jpg?v=1745317889',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blackcurrant-Rebena.jpg?v=1745317889'
                    ],
                    [
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Pink-Guava.jpg?v=1745317892',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Pina-Colada.jpg?v=1745317892',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Melon-Banana.jpg?v=1745317892'
                    ]
                ],
                [
                    [
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Cherry-Fizz.jpg?v=1745317889',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Senorita_90482be8-2540-4a78-a78e-7c0e9c56a596.jpg?v=1745317893',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Paradise-Punch.jpg?v=1745317892'
                    ],
                    [
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blueberry-Pom.jpg?v=1745317890',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blue-Cirtus.jpg?v=1745317887',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Pina-Daiquiri.jpg?v=1745317892'
                    ],
                    [
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Citrus-Mango-Guava.jpg?v=1745317892',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Pink-Lemon-Bubbly.jpg?v=1745317893',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Cherry-Peach-Lemon.jpg?v=1745317892'
                    ]
                ],
                [
                    [
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Strawberry-Melon.jpg?v=1745317892',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blue-Mist.jpg?v=1745317889',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Mint-Mix.jpg?v=1745317892'
                    ],
                    [
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Strawberry-Raspberry-Mojito.jpg?v=1745317893',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Pineapple-Freeze.jpg?v=1745317892',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Lemon-Lime.jpg?v=1745317892'
                    ],
                    [
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Strawberry-Raspberry-Cherry.jpg?v=1745317893',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Berry-Lemon.jpg?v=1745317888',
                        'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Berries-Burst.jpg?v=1745317889'
                    ]
                ],
            ],
            isSaving: false,
        }
    }, 
    methods:{
        preloadFlavorImages() {
            for (let i = 0; i <= 2; i++) {
              for (let j = 0; j <= 2; j++) {
                for (let k = 0; k <= 2; k++) {
                  const url = this.flavorArr[i][j][k];
                  const img = new Image();
                  img.src = url;
                }
              }
            }
        },
        downloadImg() {
            if (this.isSaving) return;
            showMessage('Downloading, please wait. . .','success')
            this.isSaving = true;
            axios({
                url: this.flavorArr[this.active1][this.active2][this.active3],
                method: 'GET',
                responseType: 'blob', // 关键：以二进制 Blob 接收
            }).then(res => {
                const blobUrl = URL.createObjectURL(res.data);
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = 'myFlavor.jpg';
                a.click();
                URL.revokeObjectURL(blobUrl); // 释放内存
                this.isSaving = false;
            }).catch(error => {
                showMessage('Download failed, please refresh and try again','error')
                console.log(error);
                this.isSaving = false;
            });
        },
        unlock(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true
            }else{
                if(this.active1 == -1 || this.active2 == -1 || this.active3 == -1){
                    showMessage('Please select your favorite flavor','error')
                }else{
                    this.popup = this.sharePopup = true
                    setTimeout(() => {
                        $('.bp_share').addClass('center')
                    }, 200);
                }
            }
        },
        selectFlavor(id,index){
            if(!this.isLogin){
                this.endTips()
                //this.popup = this.loginPopup = true
            }else{
                this[`active${id}`] = index;
            }
        },
        showRule(){
            this.popup=this.rulePopup=true;
            setTimeout(() => {
                $('.bp_rule').addClass('center')
            }, 200);
        },
        closePopup(id){
            if(id==1){
                this.popup=this.rulePopup=false;
                $('.bp_rule').removeClass('center')
            }else{
                this.popup=this.sharePopup=false;
                $('.bp_share').removeClass('center')
            }
        },
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );

            if (targetCountry) {
                // 滚动到目标国家
                targetCountry.scrollIntoView({ block: 'start' });
            }
        },
        endTips(){
            showMessage('The event has ended, thank you for your participation.','success')
        },
        // 发送邮箱验证
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
            }else{
                // 邮箱正则表达式
                var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(emailReg.test(this.user.email)){
                    if(!this.sendFlag){
                        this.sendText = 'Has sent'
                        this.sendFlag = true
                        var params=new URLSearchParams();
                        params.append('info',JSON.stringify(this.user));
                        let res = await axios.post('https://service.oxvatech.cn/oxva/sendEmail',params);
                        if(res.data.status == 200){
                            this.isSend = true
                            showMessage('Email has been sent, please check.','success')
                        }
                    }else{
                        showMessage('Sent, please try again in one minute.','success')
                        setTimeout(() => {
                            this.sendFlag = false
                            this.sendText = 'Send code'
                        }, 1000*60);
                    }
                    
                }else{
                    showMessage('Email format error','error')
                }
            }
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        //登录
        async loginActivity(){
            if(this.isSend){
                if(this.user.name == '' || this.user.email == '' || this.user.country == 'Country' || this.user.code == ''){
                    showMessage('Please fill in the information completely','error')
                }else{
                    // 邮箱正则表达式
                    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                    if(emailReg.test(this.user.email)){
                        //避免重复提交
                        if(!this.loginFlag){
                            this.loginFlag = true
                            var params=new URLSearchParams();
                            params.append('info',JSON.stringify(this.user));
                            let res = await axios.post('https://service.oxvatech.cn/oxva/loginActivity',params);
                            if(res.data.status == 200){
                                this.isLogin = true
                                this.setCookie('_oxpassion_flavor_',res.data.data,40)
                                showMessage('Login successful','success')
                                this.popup = this.loginPopup = false
                                setTimeout(() => {
                                    location.reload()
                                }, 500);
                            }else if(res.data.status == 201){
                                this.loginFlag = false
                                showMessage('Email verification code error','error')
                            }else if(res.data.status == 202){
                                this.loginFlag = false
                                showMessage('Username already exists','error')
                            }  
                        }
                    }else{
                        showMessage('Email format error','error')
                    }
                }
            }else{
                showMessage('Please send the email verification code first','error')
            }
        },
        //用于登录后刷新页面时获取用户信息
        async getInfo(){
            let params=new URLSearchParams();
            params.append('info',JSON.stringify({token:this.user.token}));
            let res = await axios.post('https://service.oxvatech.cn/oxva/getInfo',params);
            if(res.data.status == 200){
                if(res.data.data.length>0){
                    this.isLogin = true
                    this.user = res.data.data[0]
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        // cookie
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }
        },
    },
    created(){
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        //判断登录状态
        this.user.token = this.getCookie('_oxpassion_flavor_')
        if(this.user.token != ''){
            this.isLogin = true
            //获取用户信息
            //this.getInfo()
        }

        //this.getCountry()
    },
    mounted(){
        //this.getCountry()

        this.preloadFlavorImages()

        $(window).on('resize', updatePath);
        function updatePath(){
            $('.box3_blob').css('offsetPath', `path("M 0 0 H ${$('.box3_content').width()} V ${$('.box3_content').height()} H 0 V 0 Z")`);
        }
        updatePath()
    
        if(Wflag){
            ScrollTrigger.create({
                trigger:'.box1',
                start:'top top+=10%',
                end:'+=20%',
                // markers:true,
                // onEnter:()=>{
                //     $('.box1_img div img').addClass('box1_active')
    
                // },
                animation:gsap.timeline()
                    .from('.box1_img div img:nth-child(1)',{x:'20rem',scale:0,duration:0.3})
                    .from('.box1_img div img:nth-child(2)',{x:'27rem',scale:0,duration:0.3},'<50%')
                    .from('.box1_img div img:nth-child(3)',{x:'25rem',scale:0,duration:0.3},'<50%')
                    .from('.box1_img div img:nth-child(4)',{x:'25rem',scale:0,duration:0.3},'<50%')
                    .from('.box1_time',{opacity:0,duration:0.3},'<50%')
            }) 
        }else{
            setTimeout(() => {
                $('.box1_Mimg img:nth-child(2)').addClass('showup')
                $('.box1_Mimg img:nth-child(3)').addClass('showup')
            }, 500);
        }

        gsap.from('.box2_title',{
            y:'2rem',opacity:0,ease:'none',duration:0.5,
            scrollTrigger:{
                trigger:'.box2_title',
                start:'top bottom-=20%',
                end:'+=0',
                toggleActions:'play none none reverse',
            }
        })
    
        new Swiper('.box2Swiper', {
            autoplay: true,
            loop:true,
            slidesPerView: box2V,
            slideToClickedSlide: true,
            centeredSlides: true,
        })

        gsap.from('.box3_content',{
            y:'2rem',opacity:0,ease:'none',duration:0.5,
            scrollTrigger:{
                trigger:'.box3_content',
                start:'top bottom-=20%',
                end:'+=0',
                toggleActions:'play none none none',
            }
        })
        
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top center+=10%',
            end:'+=20%',
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                if(index>2){
                    $('.box3_bless').css({transform:'translate(0,0)',opacity:1})
                    setTimeout(()=>{
                        $('.box3_icon3').css({opacity:1})
                    },500)
                }
            }
        })

        //box9_1
        new Swiper('.box9_1Swiper', {
            speed:box9S,
            autoplay: {
            delay: 0,
            disableOnInteraction: false,
            //waitForTransition: false,
            },
            slidesPerView:box9V,
            loop:true
        })
    }
})